import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Public login page. There's no local-password UI by design — this just
 * triggers the Entra OIDC redirect via the backend's `/auth/entra/login`
 * endpoint, which is server-side so the state cookie can be HS-signed.
 */
export function LoginPage() {
  const [params] = useSearchParams();
  const returnTo = params.get("return_to") ?? "/";

  // Auto-bounce to Entra. We keep the markup so a slow redirect still shows
  // the user something contextual rather than a flash of empty page.
  useEffect(() => {
    const t = window.setTimeout(() => {
      window.location.href = `/auth/entra/login?return_to=${encodeURIComponent(returnTo)}`;
    }, 150);
    return () => window.clearTimeout(t);
  }, [returnTo]);

  return (
    <div className="wm-shell-bg relative min-h-screen overflow-hidden">
      <div className="wm-grid-overlay absolute inset-0" aria-hidden />
      <div className="relative mx-auto flex max-w-md flex-col items-center justify-center px-6 py-32 text-center">
        <h1 className="font-display text-3xl text-wm-white">Windmill ID</h1>
        <p className="mt-2 text-sm text-wm-gray-100/70">
          Signing you in with Microsoft…
        </p>
        <p className="mt-8 text-xs text-wm-gray-100/40">
          If you're not redirected,{" "}
          <a
            href={`/auth/entra/login?return_to=${encodeURIComponent(returnTo)}`}
            className="text-wm-purple-bright underline"
          >
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
}
